import { NgModule } from '@angular/core';

import { ButtonsComponent } from './buttons.component';
import { CommonModule } from '@angular/common';
import { ButtonsDirective } from './buttons.directive';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [CommonModule, FontAwesomeModule],
  exports: [ButtonsComponent],
  declarations: [ButtonsComponent, ButtonsDirective],
})
export class ButtonsModule {}
